import './global.css';
import './scss/App.scss';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ToastContainer } from 'react-toastify';
import { ErrorFallback } from '@components/elements/ErrorBoundary/ErrorFallback';
import { GoogleMapsProvider } from '@state/googleMapsProvider';
import ChatProvider from '@providers/ChatProvider';
import { theme } from '@theme/theme';
import { isNonProduction } from '@utils/Environment';
import VersionAndBuildTime from '@components/elements/VersionAndBuildTime/VersionAndBuildTime';
import AppRoutes from './routes/AppRoutes';
import 'react-toastify/dist/ReactToastify.css';

export default function App() {
  return (
    <MantineProvider withGlobalClasses={false} theme={theme}>
      <Notifications position="top-right" />
      <GoogleMapsProvider>
        <BrowserRouter>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <ChatProvider>
              <AppRoutes />
              {isNonProduction() && <VersionAndBuildTime />}
            </ChatProvider>
          </ErrorBoundary>
          <ToastContainer theme="light" />
        </BrowserRouter>
      </GoogleMapsProvider>
    </MantineProvider>
  );
}
